module.exports = __webpack_public_path__ + "img/65729.7480463d.png";